import { Card } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const CardIntegrationStatus = props => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card
      sx={{
        padding: '8px',
        textAlign: 'center',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <span style={{ fontSize: '14px', color: '#6b7280' }}>{t('cookies:show.integrationStatus.label')}</span>
      <br />
      <div
        style={{
          height: '35px',
          width: '35px',
          borderRadius: '50%',
          backgroundColor: props.disclaimerStatusAtivo ? 'green' : 'red',
          marginInline: 'auto',
          marginBlockStart: '8px',
        }}
      >
        &nbsp;
      </div>
    </Card>
  );
};
